export default __webpack_public_path__ + "static/SR India - Pesticides - Statement-a909479fbed384ed5598a2d233665554.pdf";